import { IMAGELOADINGENUMS } from '@et/types/Enums'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

interface Props {
  frame?: boolean
  image: IGatsbyImageDataObject
  alt?: string
}

function Polaroid1(props: Props) {
  const { frame = true, image, alt } = props
  const frameCss = 'z-2 h-full bg-white relative p-4 shadow-[0_4px_6px_rgba(50,50,93,.11),_0_1px_3px_rgba(0,0,0,.08)] [&>.gatsby-image-wrapper]:h-full'

  const noFrameCss = 'no-frame [&>.gatsby-image-wrapper]:absolute [&>.gatsby-image-wrapper]:w-full [&>.gatsby-image-wrapper]:h-full'

  return (
    <div className='relative flex flex-col w-full h-full bg-white et-polaroid'>
      <div className={frame ? frameCss : noFrameCss}>
        <GatsbyImage alt={alt ? alt : 'every-tuesday.com polaroid photo effect'} image={image.gatsbyImageData}
          loading={IMAGELOADINGENUMS.LAZY} />
      </div>
    </div>
  )
}

export default Polaroid1
